import type { LogsInitConfiguration } from '@datadog/browser-logs';

type LogLevel = 'info' | 'error' | 'warn' | 'debug';

declare global {
  interface Window {
    browserLogger: BrowserLogger;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DD_LOGS?: { logger: any; getInitConfiguration: () => LogsInitConfiguration | undefined };
  }
}

/**
 * メッセージをDatadogに送信する
 * DD_LOGSが利用できない場合(L4A環境など)は、エラーを投げずに実行をスルーする
 */
export class BrowserLogger {
  private log(level: LogLevel, message: string, context?: object, error?: Error): void {
    if (!this.isAvailable()) {
      return;
    }

    const logger = (window as Window).DD_LOGS?.logger;

    if (!!logger && typeof logger[level] === 'function') {
      logger[level](message, context, error);
    }
  }

  private isAvailable(): boolean {
    return typeof window !== 'undefined' && !!(window as Window).DD_LOGS && !!(window as Window)?.DD_LOGS?.logger;
  }

  info(message: string, context?: object, error?: Error): void {
    this.log('info', message, context, error);
  }

  error(message: string, context?: object, error?: Error): void {
    this.log('error', message, context, error);
  }

  warn(message: string, context?: object, error?: Error): void {
    this.log('warn', message, context, error);
  }

  debug(message: string, context?: object, error?: Error): void {
    this.log('debug', message, context, error);
  }
}

(window as Window).browserLogger = new BrowserLogger();
